import { TrainRoute } from "features/CenterContent/VehicleDetails/TrainDetails/useTrainRoute";
import { countryCode } from "shared/types/countryCode";

export const getParametersForNorwegianTrainInSweden = (
  trainRoute: TrainRoute | undefined,
) => {
  const isNorwegianTrainInSweden =
    trainRoute?.trainIdentifier.countryCode === countryCode.enum.SE &&
    trainRoute?.stops.some((stop) => stop.stopId === "Kogr");
  const norwegianTrainStaffCountryCode = isNorwegianTrainInSweden
    ? countryCode.enum.NO
    : undefined;
  const norwegianTrainId = isNorwegianTrainInSweden
    ? trainRoute?.advertisedTrainNumber?.identifier
    : undefined;

  return {
    isNorwegianTrainInSweden,
    norwegianTrainStaffCountryCode,
    norwegianTrainId,
  };
};
